import { render, staticRenderFns } from "./view.html?vue&type=template&id=24f1c1ab&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=24f1c1ab&scoped=true&lang=less&"
import style1 from "./style_mobile.less?vue&type=style&index=1&id=24f1c1ab&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f1c1ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24f1c1ab')) {
      api.createRecord('24f1c1ab', component.options)
    } else {
      api.reload('24f1c1ab', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=24f1c1ab&scoped=true&", function () {
      api.rerender('24f1c1ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/upgrade/detail/index.vue"
export default component.exports